import { render, staticRenderFns } from "./FirmMessage.vue?vue&type=template&id=58793946&scoped=true&"
import script from "./FirmMessage.vue?vue&type=script&lang=js&"
export * from "./FirmMessage.vue?vue&type=script&lang=js&"
import style0 from "./FirmMessage.vue?vue&type=style&index=0&id=58793946&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58793946",
  null
  
)

export default component.exports